import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "announcement-content" }
const _hoisted_2 = ["innerHTML"]

import { computed, watch } from 'vue';
import { useGameStore } from '@/stores/gameStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpecialAnnouncement',
  setup(__props) {

const gameStore = useGameStore();

const formattedText = computed(() =>
    gameStore.specialAnnouncement?.replace(/{{(.*?)}}/g, '<strong class="player-name-highlight">$1</strong>') || ''
);

const clear = () => {
    gameStore.clearSpecialAnnouncement();
};

watch(() => gameStore.specialAnnouncement, (newVal) => {
    if (newVal) {
        setTimeout(() => {
            clear();
        }, 4000);
    }
});

return (_ctx: any,_cache: any) => {
  return (_unref(gameStore).specialAnnouncement)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "announcement-overlay",
        onClick: clear
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", { innerHTML: formattedText.value }, null, 8, _hoisted_2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})